var render = function render(){var _vm=this,_c=_vm._self._c;return _c('owal-button',{staticClass:"add-detectable-button",staticStyle:{"margin":"0.5rem .5rem .0rem 0"},attrs:{"tooltip":_vm.tooltip,"tooltipDirection":"right"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{staticStyle:{"color":"rgba(168, 168, 168, 1)"},attrs:{"icon":_vm.icon,"size":"lg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }